<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useDialogResponseStore } from './../store';

const dialogResponseStore = useDialogResponseStore();
const { isOpenDialog, message } = storeToRefs(dialogResponseStore);
const { closeResponseModal } = dialogResponseStore;
</script>

<template>
	<v-dialog v-model="isOpenDialog">
		<h2>{{ message }}</h2>

		<v-button style="width: 100%" @click="closeResponseModal">
			Понятно
		</v-button>
	</v-dialog>
</template>
